<div class="grid justify-content-center">
  <div class="col-12 md:col-6">
    <ng-container *ngTemplateOutlet="leftTemplate"></ng-container>
  </div>
  <div class="col-12 md:col-6 text-right">
    <ng-container *ngTemplateOutlet="rightTemplate"></ng-container>
  </div>
</div>
